<template>
  <panel>
    <div class="title">
      <h2>{{ $t('home.currentJewelInfo.balance') }}</h2>
      <div class="button">
        <enlil-button @click="fetch" :disabled="!isLoggedIn || isFetching">
          <span v-if="isFetching"><loading-wheel/></span>
          <span v-else>{{ $t('home.currentJewelInfo.refresh') }}</span>
        </enlil-button>
      </div>
    </div>

    <p v-if="!isError">
      <span class="jewel_balance">
        <span v-if="isFetching" class="loading">-,---</span>
        <span v-if="isFetched">{{ numberFormat(jewelBalance) }}</span>
      </span>
      {{ $t('jewelUnit') }}
    </p>
    <p v-else class="error">{{ $t('home.currentJewelInfo.error') }}</p>

    <div v-if="!isBelongingToAgency">
      <enlil-button :block="true" :disabled="!isExchangeable" @click="onRequestButtonClick">{{ $t('home.currentJewelInfo.doRequest') }}</enlil-button>
      <p class="note">
        {{ $t('home.currentJewelInfo.registerBankAccount.prefix') }}
        <a :href="bankAccountRegisterationFormURL" target="_blank">{{ $t('home.currentJewelInfo.registerBankAccount.link') }}</a>
        {{ $t('home.currentJewelInfo.registerBankAccount.suffix') }}
      </p>
      <p class="note">
        {{ $t('home.currentJewelInfo.exchangeNote.prefix') }}
        <a href="/jewelterm.html" target="_blank">{{ $t('home.currentJewelInfo.exchangeNote.link') }}</a>
        {{ $t('home.currentJewelInfo.exchangeNote.suffix') }}
      </p>
      <p class="note">{{ $t('home.currentJewelInfo.exchangeRequirement', { leastRequiredBalance: numberFormat(leastRequiredBalance), requiredStep: numberFormat(requiredStep) }) }}</p>
      <p class="note">{{ $t('home.currentJewelInfo.dueDateNote') }}</p>
      <p class="note">{{ $t('home.currentJewelInfo.dueDatePrecautions1') }}</p>
      <p class="note">{{ $t('home.currentJewelInfo.dueDatePrecautions2') }}</p>
    </div>
  </panel>
</template>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .button {
    font-size: 0.7em;
  }
}

.jewel_balance {
  font-size: 3em;

  .loading {
    color: #999;
  }
}

.note {
  text-align: center;
  font-size: 0.8em;
  color: #808080;
}

.error {
  font-size: 0.8em;
  color: #990000;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import EnlilButton from '../../../components/EnlilButton.vue'
import LoadingWheel from '../../../components/LoadingWheel.vue'
import Panel from '../../../components/Panel.vue'

export default {
  name: 'current-jewel-balance-panel',
  components: {
    EnlilButton,
    LoadingWheel,
    Panel
  },
  computed: {
    ...mapGetters('session', ['isLoggedIn']),
    ...mapGetters('currentUserInfo', ['isExchangeable']),
    ...mapState('serverConstants', { leastRequiredBalance: 'leastJewelToExchange', requiredStep: 'exchangeStep' }),
    ...mapState('currentUserInfo', ['isFetching', 'isFetched', 'isError', 'jewelBalance', 'isBelongingToAgency', 'userId', 'userTwitterId']),
    bankAccountRegisterationFormURL () {
      return `https://docs.google.com/forms/d/e/1FAIpQLSfkGI6poK7YS7lqEE1BrUVkFDOTkbGQ-Ed9xbVgT6Vkx22pug/viewform?usp=pp_url&entry.786333557=${this.userTwitterId}&entry.149847012=${this.userId}`
    }
  },
  async mounted () {
    if (this.isLoggedIn && !this.isFetched && !this.isFetching) {
      await this.fetch()
    }
  },
  methods: {
    ...mapMutations('requestForm', ['clearRequestUUID']),
    ...mapActions('currentUserInfo', ['fetch']),
    numberFormat (num) {
      return (num || 0).toLocaleString()
    },
    onRequestButtonClick () {
      this.clearRequestUUID()
      this.$router.push('/request_exchange')
    }
  }
}
</script>
